module.exports = __webpack_public_path__ + "img/featured-morning-star.f5eeb015.png";